import React from 'react'
import underConstruction from '../images/under-construction.png'

const Resume = () => (
  <div>
    <h1>Resume</h1>
    <img style={{ height: '100%', width: '100%' }} src={underConstruction} />
  </div>
)

export default Resume



// WEBPACK FOOTER //
// ./src/pages/resume.js